import { useState, useEffect } from "react";
import { Menu, X, ArrowRight } from "lucide-react";
import logo from './logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    // Lock body scroll when menu is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const toggleMenu = () => setIsOpen(!isOpen);

  const navLinks = [
    { name: "Home", href: "#home" },
    { name: "Products", href: "#products" },
    { name: "About Us", href: "#about" },
    { name: "Contact", href: "#contact" },
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${scrolled || isOpen
        ? "bg-white shadow-md py-4"
        : "bg-transparent py-4 sm:py-6"
        }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img src={logo} alt="Uma Ispat Logo" className="h-10 sm:h-12 w-auto object-contain" />
            <span className={`text-xl sm:text-2xl font-bold font-heading tracking-tight ${scrolled || isOpen ? 'text-primary' : 'text-white'}`}>
              Uma Ispat
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`text-sm font-medium transition-colors relative group ${scrolled ? 'text-secondary hover:text-accent' : 'text-slate-200 hover:text-white'}`}
              >
                {link.name}
                <span className={`absolute -bottom-1 left-0 w-0 h-0.5 transition-all group-hover:w-full ${scrolled ? 'bg-accent' : 'bg-white'}`}></span>
              </a>
            ))}
            <a
              href="#contact"
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 flex items-center gap-2 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 ${scrolled ? 'bg-primary text-white hover:bg-accent' : 'bg-white text-primary hover:bg-slate-100'}`}
            >
              Get Quote <ArrowRight size={16} />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className={`transition-colors p-2 z-50 ${isOpen ? 'text-primary' : (scrolled ? 'text-primary' : 'text-white')}`}
              aria-label="Toggle menu"
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 bg-primary z-40 transform transition-transform duration-500 ease-in-out md:hidden flex flex-col h-[100dvh] ${isOpen ? "translate-x-0" : "translate-x-full"
          }`}
      >
        <div className="flex flex-col h-full justify-center px-8 space-y-8 mt-12 overflow-y-auto">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={() => setIsOpen(false)}
              className="text-2xl font-heading font-bold text-white hover:text-accent transition-colors"
            >
              {link.name}
            </a>
          ))}
          <div className="pt-4">
            <a
              href="#contact"
              onClick={() => setIsOpen(false)}
              className="inline-block w-full bg-accent text-white px-8 py-4 rounded-xl text-lg font-bold text-center hover:bg-blue-700 transition-all shadow-xl active:scale-95"
            >
              Get a Quote
            </a>
          </div>

          <div className="pt-8 border-t border-white/10">
            <p className="text-slate-500 text-xs mb-3 tracking-widest uppercase">Contact Info</p>
            <p className="text-white text-xl font-bold mb-1">+91 90519 99959</p>
            <p className="text-slate-400 text-sm">info@umaispat.com</p>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
